export const mapDataForScatterplot = ({
  data = [],
  colors = [],
  xPlotlines = [],
  yPlotlines = [],
  xAxisMetricName = '',
  yAxisMetricName = '',
  xAxisMetric = '',
  yAxisMetric = ''
}) => {

    const options = createOptions({
        seriesList: data,
        colors,
        xPlotlines,
        yPlotlines,
        xAxisMetricName,
        yAxisMetricName,
        xAxisMetric,
        yAxisMetric,
    });

    return options;
};

export const createOptions = ({
    seriesList = [],
    xPlotlines = [],
    yPlotlines = [],
    xAxisMetricName = '',
    yAxisMetricName = '',
    xAxisMetric = '',
    yAxisMetric = '',
    tooltip = {},
    colors,
    show,
    showHamburger = true
}) => {
  
  const isXAxisDate = xAxisMetric === 'date';
  let xDateCategories = [];
  let processedSeriesList = seriesList;

  // Process data only if x-axis is date
  if (isXAxisDate) {
    const dateSet = new Set();
    seriesList.forEach(series => {
      if (series.data) {
        series.data.forEach(point => {
          // Only include dates that have a valid y-value
          if (point.date && point.y !== null && point.y !== undefined && point.y !== '') {
            dateSet.add(point.date);
          }
        });
      }
    });
    xDateCategories = Array.from(dateSet).sort();

    processedSeriesList = seriesList.map(series => {
      if (!series.data) return series;
      
      const processedData = series.data
        .filter(point => {
          return point.y !== null && point.y !== undefined && point.y !== '';
        })
        .map(point => {
          return {
            ...point,
            x: xDateCategories.indexOf(point.date)
          };
        });
      
      return { ...series, data: processedData };
    });
  }
  
  tooltip = {
    ...tooltip,
    shared: true,
    formatter: function () {
      const dateLine = `<strong>${this.point?.date}</strong> <br>`
      const gameDate = this.point?.gameday ? `${this.point.gameday} <br>` : ''
      const nameLine = this.point?.name ? `${this.point?.name} <br>` : ''
      const positionLine = this.point?.position ? `${this.point?.position} <br>` : ''

      let xValue = this.point?.x;
      if (isXAxisDate && typeof xValue === 'number') {
        // x is the category index, get the actual date
        xValue = xDateCategories[xValue] || this.point?.date;
      }

      let yValue = this.point?.y;
      const xLine = `${xAxisMetricName}: ${xValue} <br>`
      const yLine = `${yAxisMetricName}: ${yValue}`
      return dateLine + gameDate + nameLine + positionLine + xLine + yLine;
    }
  }

  const options = {
    chart: {
      type: 'scatter',
      zoomType: 'xy'
    },
    title: {
      text: `${xAxisMetricName} by ${yAxisMetricName}`
    },
    xAxis: {
      title: {
        text: xAxisMetricName
      },
      type: isXAxisDate ? 'category' : 'linear',
      categories: isXAxisDate ? xDateCategories : undefined,
      plotLines: [],
    },
    yAxis: {
        title: {
            text: yAxisMetricName
        },
        plotLines: [],
    },
    legend: {
      enabled: true,
      verticalAlign: 'top',
      layout: 'horizontal'
    },
    plotOptions: {
        scatter: {
            marker: {
                radius: 2.5,
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        lineColor: 'rgb(100,100,100)'
                    }
                }
            },
            states: {
                hover: {
                    marker: {
                        enabled: false
                    }
                }
            },
            jitter: {
                x: 0.005
            }
        }
    },
    colors,
    series: processedSeriesList,
    tooltip,
    exporting: {
      enabled: showHamburger, // Enables the export button
      chartOptions: { // specific options for the exported image
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: false
                }
            }
        }
      },
      fallbackToExportServer: false
    },
  };

  if (xPlotlines.length && !isXAxisDate) {
    xPlotlines.forEach( (plotlineValue, index) => {
      plotlineValue = parseFloat(plotlineValue)?.toFixed(2)
      const plotline = {
        id: `x-${index}`,
        dashStyle: 'ShortDash',
        color: 'black',
        value: plotlineValue,
        zIndex: 5,
        label: {
          text: plotlineValue,
          rotation: 0,
          style: {
            zIndex: 60001 
          }
        }
      }
      options.xAxis.plotLines.push(plotline);
    })
  }

  if (yPlotlines.length) {
    yPlotlines.forEach( (plotlineValue, index) => {
      plotlineValue = parseFloat(plotlineValue)?.toFixed(2)
      const plotline = {
        id: `y-${index}`,
        dashStyle: 'ShortDash',
        color: 'black',
        value: plotlineValue,
        zIndex: 5,
        label: {
          text: plotlineValue,
          align: 'right',
          style: {
            zIndex: 60001 
          }
        }
      }
      options.yAxis.plotLines.push(plotline);
    })
  }

  return options;
};
